import React from 'react';

export default function useHotspotPositions(ref: any) {
  const [top, setTop] = React.useState(0);
  const [left, setLeft] = React.useState(0);

  const getBoxHeightPromise = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(ref?.current?.clientHeight);
      }, 0);
    });
  };

  const handleTop = async (data: any) => {
    const { deltaY, isHotspotSingle } = data;

    let calculatedTop = 0;
    const screenHeight = window.innerHeight;
    let boxHeight: any = await getBoxHeightPromise();
    let factor = 0;

    if (deltaY < screenHeight / 2) {
      // show hotspot on the bottom half of the screen
      factor = 1.02;
      const isTopStatus = deltaY * factor + boxHeight > screenHeight;

      calculatedTop = isTopStatus ? 0 : deltaY * factor;
    } else {
      // show hotspot on the top half of the screen

      factor = 1.15;
      // if hotspot box has not arrow next and back
      if (isHotspotSingle) {
        calculatedTop = deltaY - boxHeight < 0 ? 0 : deltaY - boxHeight + 25;
      } else {
        // hotspot box without arrow next and back
        calculatedTop =
          deltaY - boxHeight / factor < 0 ? 0 : deltaY - boxHeight / factor;
      }
    }

    setTop(calculatedTop);
  };

  const handleLeft = (data: any) => {
    const { deltaX } = data;

    let calculatedLeft = 0;

    calculatedLeft = deltaX - 350 / 1.1;

    if (calculatedLeft < 0) {
      setLeft(deltaX + 30);
      return;
    }

    setLeft(calculatedLeft);
  };

  return { handleTop, handleLeft, top, left };
}
